import { createUseStyles } from 'react-jss';
import {
  primaryButtonStyle,
  buttonSizeMap,
} from '../../constants/ButtonStyles';
import {
  cssColorDark,
  cssColorPrimary,
  formUi,
} from '../../constants/globalcss';

// Extract styles using react-jss
export const useStyles = createUseStyles({
  // HomeMenu styles
  menuContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  // MenuItem styles
  menuItem: {
    ...primaryButtonStyle,
    ...buttonSizeMap.medium,
    borderRadius: formUi.card.radius,
    marginBottom: 0,
    minHeight: 56,
    textAlign: 'center',
    textTransform: 'none',
    width: '100%',
  },
  menuItemsContainer: {
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(auto-fill, minmax(152px, 1fr))',
    width: '100%',
  },
  menuTitle: {
    color: cssColorDark,
    fontWeight: 500,
    marginBottom: 24,
    textAlign: 'center',
  },

  // ViewToggle styles
  toggleGroup: {
    '& .MuiToggleButton-root': {
      '&.Mui-selected': {
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
        },
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        color: 'white',
      },
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
      border: '1px solid rgba(255, 255, 255, 0.5)',
      color: 'white',
    },
    marginRight: 16,
  },
  toggleIcon: {
    '@media (min-width: 600px)': {
      marginRight: 8,
    },
  },
  toggleText: {
    '@media (max-width: 599px)': {
      display: 'none',
    },
    '@media (min-width: 600px)': {
      display: 'block',
    },
  },
});
